
    function deshorten(arrOfArr) {
      var headers = arrOfArr.headers;
      var data = arrOfArr.data;
      return data.map(function (d) {
        var o = {};
        headers.forEach(function (h, i) {
          o[h] = d[i];
        })
        return o;
      });
    }

    var str = '{"headers":["sector","subsector","emission_mmt_co2","emission_percentage"],"data":[["agriculture","Agriculture",6509.88,73.96],["agriculture","LULUCF",640.16,7.27],["agriculture","Waste",1652,18.77],["buildings","Commercial energy combustion",501.21,14.12],["buildings","HFCs from refrigeration and A/C",867.6,24.45],["buildings","Residential energy combustion",2179.66,61.43],["electricity","Combined Heat and Power",2528.71,19.1],["electricity","Electric Power",10707.39,80.9],["manufacturing","Fugitive emissions",2778.19,19.02],["manufacturing","Iron and Steel",2388.22,16.35],["manufacturing","Non-Metallic Minerals",2973.08,20.35],["manufacturing","Other",6467.04,44.27],["transportation","Domestic aviation",265.28,3.7],["transportation","Domestic marine",173.35,2.42],["transportation","International aviation",283.51,3.96],["transportation","International marine",626.26,8.74],["transportation","Other",37.24,0.52],["transportation","Pipeline",148.51,2.07],["transportation","Rail",83.9,1.17],["transportation","Road",5546.05,77.41]]}';
    var shortenedJson = JSON.parse(str);
    module.exports = deshorten(shortenedJson);
  